import { SVGProps } from 'react';

const SvgChevronUpSmall = (props: SVGProps<SVGSVGElement>) => (
  <svg width={16} height={16} fill="none" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fill="#081930"
      fillRule="evenodd"
      d="M11.354 10.354a.5.5 0 0 1-.708 0L8 7.707l-2.646 2.647a.5.5 0 0 1-.708-.708l3-3a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708Z"
      clipRule="evenodd"
    />
  </svg>
);

export default SvgChevronUpSmall;
